/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';
import type { OrderEditRequest } from '../types/OrderEdit';
import type { OrderPricePreviewResponse } from '../types/OrderPricePreview';

export type OrdersPricePreviewCreateRequest = OrderEditRequest;
export type OrdersPricePreviewCreateResponse = OrderPricePreviewResponse;

export type OrdersPricePreviewCreateQuery = {};

/**
 * POST /dmx-server/orders/price_preview/
 *
 * ```yaml
 * operationId: orders_price_preview_create
 * description: >-
 *   Bezstavová kalkulace ceny objednávky: vstup jako pro create, nic se neukládá.
 *
 *
 *   Vrací per-region plochy, per-publishset ceny a celkové součty (vč. DPH).
 *   Účtuje
 *
 *   se plocha unionu regionů, ne jejich součet (překryvy se nezdvojují).
 * tags:
 *   - orders
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/OrderEdit'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/OrderEdit'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/OrderEdit'
 *   required: true
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/OrderPricePreview'
 *     description: ''
 * ```
 */
export const ordersPricePreviewCreateOperation = (rest?: OrdersPricePreviewCreateQuery | null) =>
  ({
    method: 'POST',
    path: `/dmx-server/orders/price_preview/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'POST';
    path: string & { _templateUrl: '/dmx-server/orders/price_preview/' };
  };

/**
 * POST /dmx-server/orders/price_preview/
 *
 * ```yaml
 * operationId: orders_price_preview_create
 * description: >-
 *   Bezstavová kalkulace ceny objednávky: vstup jako pro create, nic se neukládá.
 *
 *
 *   Vrací per-region plochy, per-publishset ceny a celkové součty (vč. DPH).
 *   Účtuje
 *
 *   se plocha unionu regionů, ne jejich součet (překryvy se nezdvojují).
 * tags:
 *   - orders
 * requestBody:
 *   content:
 *     application/json:
 *       schema:
 *         $ref: '#/components/schemas/OrderEdit'
 *     application/x-www-form-urlencoded:
 *       schema:
 *         $ref: '#/components/schemas/OrderEdit'
 *     multipart/form-data:
 *       schema:
 *         $ref: '#/components/schemas/OrderEdit'
 *   required: true
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     content:
 *       application/json:
 *         schema:
 *           $ref: '#/components/schemas/OrderPricePreview'
 *     description: ''
 * ```
 */
export const ordersPricePreviewCreate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query?: OrdersPricePreviewCreateQuery;
  request: OrderEditRequest;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<OrderPricePreviewResponse>> => {
  const operation = ordersPricePreviewCreateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'POST',
    request,
    onUploadProgress,
    cancelToken,
  );
};
